export default __webpack_public_path__ + "static/media/research.0209f87f.svg";